<template>
  <teleport to="body">
    <fullscreen-modal
      v-for="entry in modals"
      :key="entry.id"
      :component="entry.component"
      :properties="entry.properties"
      :modal-handle="entry.handle"
      v-bind="entry.options"
    />
  </teleport>
</template>

<script>
import { modalStack } from '@/plugins/FullscreenModal.js';
import FullscreenModal from '@/ui/components/FullscreenModal.vue';

export default {
  name: 'FullscreenModalHost',
  components: {
    FullscreenModal,
  },
  computed: {
    modals() {
      return modalStack;
    },
  },
};
</script>
